// extracted by mini-css-extract-plugin
export var aboveInput = "_ns-0";
export var actionButton = "_ns-5";
export var actionButtonContainer = "_ns-1";
export var actionIcon = "_ns-6";
export var aiInfoContainer = "_ns-2";
export var attachmentWrapper = "_ns-7";
export var bold = "_ns-3";
export var checkIcon = "_ns-8";
export var clickingRecipientBar = "_ns-11";
export var commentThreadSwitch = "_ns-a";
export var draftImage = "_ns-b";
export var draftImageContainer = "_ns-c";
export var draftImages = "_ns-e";
export var editButton = "_ns-g";
export var editor = "_ns-f";
export var editorContainer = "_ns-y";
export var editorErrorTooltipWrapper = "_ns-9";
export var headerDivider = "_ns-h";
export var icon = "_ns-i";
export var info = "_ns-j";
export var internal = "_ns-n";
export var internalDivider = "_ns-k";
export var internalMessage = "_ns-l";
export var messageInputCard = "_ns-m";
export var messageInputForm = "_ns-o";
export var messageInputFormInternal = "_ns-p";
export var options = "_ns-q";
export var publicMessageCustomer = "_ns-s";
export var publicMessageMerchant = "_ns-r";
export var removeImageButton = "_ns-d";
export var replyButtons = "_ns-t";
export var showSignatureButton = "_ns-u";
export var spinner = "_ns-v";
export var verticalButtonDivider = "_ns-4";
export var visibilitySelector = "_ns-w";
export var warning = "_ns-x";
export var wrappingText = "_ns-z";
export var writingInternalNoteTopBorder = "_ns-10";